// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb-module--breadcrumb--22GNZ"};